import React, { useState } from "react";
import "./ModalManager.css"; // Using the same CSS file
import { ImCancelCircle } from "react-icons/im";

const UpdateMenuModal = ({ item, onClose, onSave }) => {
  const [updatedLabel, setUpdatedLabel] = useState(item.label);
  const [updatedUrl, setUpdatedUrl] = useState(item.url);

  const handleUpdate = () => {
    const updatedData = {
      slno: item.slno,
      label: updatedLabel,
      url: updatedUrl,
    };
    onSave(updatedData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">Update Menu URL</h3>
          <button className="modal-close-btn" onClick={onClose}>
                    <ImCancelCircle />
                  </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label className="form-label">Label</label>
            <input
              type="text"
              value={updatedLabel}
              onChange={(e) => setUpdatedLabel(e.target.value)}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">URL</label>
            <input
              type="text"
              value={updatedUrl}
              onChange={(e) => setUpdatedUrl(e.target.value)}
              className="form-input"
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="view-btn" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateMenuModal;